import { getEnvs } from "./env";

export const setMocks = async () => {
  const { MOZIO_PUBLIC_ENABLE_MOCKS } = getEnvs();

  if (!MOZIO_PUBLIC_ENABLE_MOCKS) {
    return;
  }

  const { worker } = await import("../mocks/browser");

  return worker.start({
    serviceWorker: {
      url: "/mockServiceWorker.js",
    },
  });
};
